module.exports = __webpack_public_path__ + "static/img/2023年历-3.f13ebad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-3.jpg
// module id = lGx+
// module chunks = 3